// import React from "react";
// import { VideoRecordingContent } from "../Components/VideoRecordingContent";

// const VideoRecording = () => {
//   return <VideoRecordingContent />;
// };

// export default VideoRecording;
import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import { VideoRecordingContent } from "../Components/VideoRecordingContent";

const VideoRecording = () => {
  const seoData = getSEOData("/video-recording");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <VideoRecordingContent />
    </>
  );
};

export default VideoRecording;